import { Input, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {
    hasAccesToInvoice: boolean = false;
    modelStore: any[] = [];
    modelSiege: any[] = [];

    finalMenuItemsCollections: any[] = [];

    @Input() userConnected: any;
    isAdmin: boolean = false;
    hasAccessToReporting: boolean = false
    constructor(private router: Router) {

    }
    ngOnInit() {
        let userGroupsStringCollections: string[] = [];
        if (this.userConnected) {
            this.userConnected.userGroups?.map(
                (_: any) => {
                    if (_) {  
                        userGroupsStringCollections.unshift(_.displayName);
                        
                    }

                }
            );
            if (!userGroupsStringCollections.includes("DeutschInstitut")) {
                this.router.navigateByUrl('access-denied')
            }

            if (userGroupsStringCollections.includes("Admin DI")) {
                this.isAdmin = true
            }
        }

        this.modelSiege = [
            {
                label: "Prospects & Apprenants",
                fragment: 'assets/demo/images/student-w.png',
                color: "#0025D7",
                items: [
                    {
                        label: 'Vue 360°',
                        fragment: 'assets/demo/images/audience.png',
                        routerLink: '/app-layout/M-global-view/search-customer'
                    }
                    ,
                    {
                        label: 'Liste des apprenants',
                        fragment: 'assets/demo/images/list.png',
                        routerLink: '/app-layout/M-global-view/summary-requests/requests-update'
                    }
                ]
            },
            {
                label: "Gestion des Sessions",
                fragment: 'assets/demo/images/calendar-w.png',
                color: "#FFBA00",
                items: [
                    {
                        label: 'Nouvelle session',
                        fragment: 'assets/demo/images/rond.png',
                        routerLink: '/app-layout/M-Formation/sessions/new-session/details'
                    },
                    {
                        label: 'Liste des sessions',
                        fragment: 'assets/demo/images/liste.png',
                        routerLink: '/app-layout/M-Formation/sessions/list-sessions'
                    },
                    {
                        label: 'Calendrier des séances',
                        fragment: 'assets/demo/images/time-and-calendar.png',
                        routerLink: '/app-layout/M-Formation/sessions/calender'
                    }
                ]
            },
            {
                label: "Inscriptions & paiements",
                fragment: 'assets/demo/images/wallet-w.png',
                color: "#7A00FF",
                items: [
                    {
                        label: "Inscriptions",
                        fragment: 'assets/demo/images/registerI.png',
                        items: [
                            {
                                label: 'Nouvelle inscription',
                                fragment: 'assets/demo/images/add-post.png',
                                routerLink: '/app-layout/M-Registations/new-registration'
                            },
                            {
                                label: 'Liste des inscriptions',
                                fragment: 'assets/demo/images/contract.png',
                                routerLink: '/app-layout/M-Registations/list-registrations'
                            },
                        ]
                    },
                    {
                        label: "Paiements",
                        fragment: 'assets/demo/images/money-bag.png',
                        items: [
                            //   {
                            //     label: 'Nouveau paiement',
                            //     fragment: 'assets/demo/images/add-post.png',
                            //     routerLink: '/app-layout/M-Registations/list-payments'
                            // },
                            {
                                label: 'List des paiements',
                                fragment: 'assets/demo/images/bill.png',
                                routerLink: '/app-layout/M-Registations/list-payments'
                            },
                        ]
                    }
                ]
            },
            {
                label: "Suivi recettes",
                color: "#0FC68C",
                fragment: 'assets/demo/images/money-bag-w.png',
                visible: this.isAdmin,
                items: [
                    {
                        label: 'Tableau des Recettes',
                        fragment: 'assets/demo/images/money-bag.png',
                        routerLink: '/app-layout/M-Finance/finance-tabs'
                    }
                ]
            },
            {
                label: "Paramétrage",
                color: "#C42B2B",
                fragment: 'assets/demo/images/settings-w.png',
                items: [
                    {
                        label: 'Salles',
                        fragment: 'assets/demo/images/classroom.png',
                        routerLink: '/app-layout/M-config/suppl-config',
                        items: [
                            {
                                label: 'List des salles',
                                fragment: 'assets/demo/images/liste.png',
                                routerLink: '/app-layout/M-config/romms-config'
                            }
                        ]
                    },
                    {
                        label: 'Formateurs',
                        fragment: 'assets/demo/images/driving-instructor.png',
                        routerLink: '/app-layout/M-config/suppl-config',
                        items: [
                            {
                                label: 'Liste des formateurs',
                                fragment: 'assets/demo/images/liste.png',
                                routerLink: '/app-layout/M-config/trainers-config'
                            }
                        ]
                    },
                    {
                        label: 'Formations',
                        fragment: 'assets/demo/images/online-education.png',
                        routerLink: '/app-layout/M-config/suppl-config',
                        items: [
                            {
                                label: 'List des formation',
                                fragment: 'assets/demo/images/liste.png',
                                routerLink: '/app-layout/M-config/formations-config'
                            }
                        ]
                    },
                    {
                        label: 'Options de paiement',
                        fragment: 'assets/demo/images/menu.png',
                        routerLink: '/app-layout/M-config/options-config',
                        items: [
                            {
                                label: 'List des Options',
                                fragment: 'assets/demo/images/liste.png',
                                routerLink: '/app-layout/M-config/options-config'
                            }
                        ]
                    }
                ]
            },

        ];
        this.finalMenuItemsCollections = this.modelSiege;
    }
}
